import { render, staticRenderFns } from "./MoveLeadership.vue?vue&type=template&id=664f44ac&scoped=true&"
import script from "./MoveLeadership.vue?vue&type=script&lang=js&"
export * from "./MoveLeadership.vue?vue&type=script&lang=js&"
import style0 from "./MoveLeadership.vue?vue&type=style&index=0&id=664f44ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664f44ac",
  null
  
)

export default component.exports